export const environment = {
  production: false,
  envName: 'develop',
  version: '1.0',

  /** Where this build is served; link previews and canonical URLs are absolute against it. */
  siteUrl: 'https://dev.lab.avyna.io',

  api: {
    host: 'https://catalog-api-dev.lab.avyna.io',
  },

  onboarding: {
    catalog: 'https://catalog-onboarding-dev.lab.avyna.io/login',
    
    core: '',
  },

  // Where an existing customer signs in; non-production uses the Catalog lab tier.
  apps: {
    catalog: 'https://catalog-dev.lab.avyna.io/auth/login',
    core: '',
  },

  // GA4, loaded only after consent; empty means no banner and no request to Google.
  analytics: {
    measurementId: 'G-DGBTJ9NPX2',
  },
};
